import { Injectable } from '@angular/core';
import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

@Injectable({
  providedIn: 'root',
})
export class PackageSharedService {
  designer = null;

  setDesigner(designer) {
    this.designer = designer;
  }

  getComponentsByName(name: string) {
    return this.designer.package.components.filter((item) => item.name === name && item.edit === false);
  }
}

((window as any).xplenty as angular.IModule).service('packageSharedService', downgradeInjectable(PackageSharedService));
